import { getCall, postFilesCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const getBotsTemplates = async () => {
  const res = await getCall("/whatsapp/templates/bots");
  if (res[0]) {
    return res[0].bots_templates;
  } else return null;
};

export const uploadTemplateFile = async (files) => {
  const id = loadingToast();
  const res = await postFilesCall(
    "/whatsapp/templates/global/create",
    files
  );
  if (res[0]) {
    updateToast(id, "success", "Se ha cargado el archivo correctamente.");
    return res[0].tracker_data;
  } else {
    dispatchErrorMessage(id, res, "Error al cargar el archivo.");
    return null;
  }
};